import { Toast } from 'flowbite-react';
import React, { useState } from 'react'
import { AiOutlineShoppingCart } from "react-icons/ai";
import { HiCheck, HiX } from "react-icons/hi";
import cart from '../data/cart.json'
import { useSelector } from 'react-redux'



export default function Productinfo({ cata }) {
    const user = useSelector((state) => state.user)
    const [size, setSize] = useState('L')
    const [toast, setToast] = useState()

    const Size = (e) => {
        setSize(e.target.value)
    }


    const log = () => {

        setToast(
        <Toast className='m-1'>
            <div className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-red-300 text-red-500 ">
                <HiX className="h-5 w-5" />
            </div>
            <div className="ml-3 text-sm font-normal">
                You should login
            </div>
            <Toast.Toggle />
        </Toast>)
    }


    const product = {
        "user":`${user.userName}`,
        "Ptitle": `${cata.Ptitle}`,
        "Pimg": `${cata.Pimg}`,
        "price": cata.price,
        "size": `${size}`,
        "catag": `${cata.catag}`
    }





    const addtocart = () => {
        cart.push(product)
        setToast(<Toast className=''>
            <div className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-green-100 text-green-500 ">
                <HiCheck className="h-5 w-5" />
            </div>
            <div className="ml-3 text-sm font-normal">
                Item moved successfully.
            </div>
            <Toast.Toggle />
        </Toast>)
    }
    const [warnning, setWarnning] = useState(
        <div id="alert-4" class="flex p-4 mt-3  bg-yellow-100 rounded-lg " role="alert">
            <svg aria-hidden="true" class="flex-shrink-0 w-5 h-5 text-yellow-700 " fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path></svg>
            <span class="sr-only">Info</span>
            <div class="ml-3 text-sm font-medium text-center text-yellow-700 ">
            تکایە دڵنیابەرەوە لەو سایزەی کە هەڵی دەبژێریت<br/> 
            چونکە دواتر ناتوانیت دەستکاری بکەیت
            </div>
            <button onClick={()=>{setWarnning(null)}} type="button" class="ml-auto -mx-1.5 -my-1.5 bg-yellow-100 text-yellow-500 rounded-lg focus:ring-2 focus:ring-yellow-400 p-1.5 hover:bg-yellow-200 inline-flex h-8 w-8 " data-dismiss-target="#alert-4" aria-label="Close">
                <span class="sr-only">Close</span>
                <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
            </button>
        </div>
    )


    return (
        <>

            <div class=" fixed bottom-0  left-0 right-0 z-40 top-0 p-14 mx-auto bg-black backdrop-blur-lg bg-opacity-20">

                <div class="lg:w-4/5 border-2 border-chwaram bg-dwam p-4 rounded-lg mx-auto flex flex-wrap">
                    <img alt="ecommerce" class="lg:w-1/2 w-full md:h-96 h-64  object-contain rounded" src={cata.Pimg} />
                    <div class="lg:w-1/2 w-full lg:pl-10 lg:py-6 lg:mt-0">
                        <h2 class="text-sm title-font text-gray-500 tracking-widest">{cata.catag}</h2>
                        <h1 class="text-yakam text-3xl title-font font-medium mb-1">{cata.Ptitle}</h1>
                        <div class="flex mb-4">
                            <span class="flex items-center">
                                <svg fill="currentColor" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4  text-yellow-500" viewBox="0 0 24 24">
                                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path>
                                </svg>
                                <svg fill="currentColor" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4  text-yellow-500" viewBox="0 0 24 24">
                                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path>
                                </svg>
                                <svg fill="currentColor" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4  text-yellow-500" viewBox="0 0 24 24">
                                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path>
                                </svg>
                                <svg fill="currentColor" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4  text-yellow-500" viewBox="0 0 24 24">
                                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path>
                                </svg>
                                <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4  text-yellow-500" viewBox="0 0 24 24">
                                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path>
                                </svg>
                                <span class="ml-3">4 Reviews</span>
                            </span>
                           
                        </div>
                        <p class="leading-relaxed"></p>
                        <div class="flex mt-6 items-center pb-5 border-b-2 border-gray-800 mb-3">
                            
                            <div class="flex flex-col items-center">
                                {cata.catag === 'Men\'s Kit' || cata.catag === 'Men\'s T-Shirt' || cata.catag === 'Men\'s Tracksuit' || cata.catag === 'Women\'s Kit' || cata.catag === 'Women\'s T-shirt' || cata.catag === 'tracksuit' ?
                                    (
                                        <>

                                        <div class="flex flex-wrap">
                                            <div class="flex items-center mr-4">
                                                <input onChange={Size} id="red-radio" type="radio" value="S" name="colored-radio" class="w-4 h-4 text-shasham bg-gray-100 border-gray-300 focus:ring-shasham   focus:ring-2 " />
                                                <label for="red-radio" class="ml-2 text-sm font-medium text-gray-900 ">S</label>
                                            </div>
                                            <div class="flex items-center mr-4">
                                                <input onChange={Size} id="green-radio" type="radio" value="M" name="colored-radio" class="w-4 h-4 text-shasham bg-gray-100 border-gray-300 focus:ring-shasham   focus:ring-2 " />
                                                <label for="green-radio" class="ml-2 text-sm font-medium text-gray-900 ">M</label>
                                            </div>
                                            <div class="flex items-center mr-4">
                                                <input onChange={Size} id="purple-radio" type="radio" value="L" name="colored-radio" class="w-4 h-4 text-shasham bg-gray-100 border-gray-300 focus:ring-shasham   focus:ring-2 " />
                                                <label for="purple-radio" class="ml-2 text-sm font-medium text-gray-900 ">L</label>
                                            </div>
                                            <div class="flex items-center mr-4">
                                                <input onChange={Size} id="teal-radio" type="radio" value="XL" name="colored-radio" class="w-4 h-4 text-shasham bg-gray-100 border-gray-300 focus:ring-shasham   focus:ring-2 " />
                                                <label for="teal-radio" class="ml-2 text-sm font-medium text-gray-900 ">XL</label>
                                            </div>
                                            <div class="flex items-center mr-4">
                                                <input onChange={Size} id="yellow-radio" type="radio" value="XXL" name="colored-radio" class="w-4 h-4 text-shasham bg-gray-100 border-gray-300 focus:ring-shasham   focus:ring-2 " />
                                                <label for="yellow-radio" class="ml-2 text-sm font-medium text-gray-900 ">XXL</label>
                                            </div>
                                            <div class="flex items-center mr-4">
                                                <input onChange={Size} id="orange-radio" type="radio" value="XXXL" name="colored-radio" class="w-4 h-4 text-shasham bg-gray-100 border-gray-300 focus:ring-shasham   focus:ring-2 " />
                                                <label for="orange-radio" class="ml-2 text-sm font-medium text-gray-900 ">XXXL</label>
                                            </div>
                                        </div>
                                        {warnning}
                                        </>
                                        

                                    ):
                                cata.catag==="Men's sport Shoes" || cata.catag==="Shose" ?
                                    (
                                        <>

                                        <div class="flex flex-wrap">
                                            <div class="flex items-center mr-4">
                                                <input onChange={Size} id="red-radio" type="radio" value="36" name="colored-radio" class="w-4 h-4 text-shasham bg-gray-100 border-gray-300 focus:ring-shasham   focus:ring-2 " />
                                                <label for="red-radio" class="ml-2 text-sm font-medium text-gray-900 ">36</label>
                                            </div>
                                            <div class="flex items-center mr-4">
                                                <input onChange={Size} id="green-radio" type="radio" value="37" name="colored-radio" class="w-4 h-4 text-shasham bg-gray-100 border-gray-300 focus:ring-shasham   focus:ring-2 " />
                                                <label for="green-radio" class="ml-2 text-sm font-medium text-gray-900 ">37</label>
                                            </div>
                                            <div class="flex items-center mr-4">
                                                <input onChange={Size} id="purple-radio" type="radio" value="38" name="colored-radio" class="w-4 h-4 text-shasham bg-gray-100 border-gray-300 focus:ring-shasham   focus:ring-2 " />
                                                <label for="purple-radio" class="ml-2 text-sm font-medium text-gray-900 ">38</label>
                                            </div>
                                            <div class="flex items-center mr-4">
                                                <input onChange={Size} id="teal-radio" type="radio" value="39" name="colored-radio" class="w-4 h-4 text-shasham bg-gray-100 border-gray-300 focus:ring-shasham   focus:ring-2 " />
                                                <label for="teal-radio" class="ml-2 text-sm font-medium text-gray-900 ">39</label>
                                            </div>
                                            <div class="flex items-center mr-4">
                                                <input onChange={Size} id="yellow-radio" type="radio" value="40" name="colored-radio" class="w-4 h-4 text-shasham bg-gray-100 border-gray-300 focus:ring-shasham   focus:ring-2 " />
                                                <label for="yellow-radio" class="ml-2 text-sm font-medium text-gray-900 ">40</label>
                                            </div>
                                            <div class="flex items-center mr-4">
                                                <input onChange={Size} id="orange-radio" type="radio" value="41" name="colored-radio" class="w-4 h-4 text-shasham bg-gray-100 border-gray-300 focus:ring-shasham   focus:ring-2 " />
                                                <label for="orange-radio" class="ml-2 text-sm font-medium text-gray-900 ">41</label>
                                            </div>
                                        </div>
                                        {warnning}
                                        </>
                                        

                                    ):
                                    (
                                        

                                        
                                        null
                                        
                                    )
                                }


                            </div>
                        </div>
                        <div class="flex justify-between">
                            <span class="title-font font-medium text-2xl text-c7">{cata.price}$</span>
                            {user.isAuthed ? (

                                <button onClick={addtocart} className="px-2 py-1 text-sm flex items-center font-medium text-yakam uppercase transition-colors duration-200 transform backdrop-blur-xl  bg-opacity-60 bg-white rounded hover:bg-penjam focus:bg-penjam focus:outline-none">
                                    زیادی بکە بۆ سەبەتەکەت <AiOutlineShoppingCart className='mx-2 w-6 h-6 text-yakam' />
                                </button>
                            ) : (
                                <button onClick={log} className="px-2 py-1 text-sm flex items-center font-medium text-yakam uppercase transition-colors duration-200 transform backdrop-blur-xl  bg-opacity-60 bg-white rounded hover:bg-penjam focus:bg-penjam focus:outline-none">
                                    زیادی بکە بۆ سەبەتەکەت <AiOutlineShoppingCart className='mx-2 w-6 h-6 text-yakam' />
                                </button>
                            )}

                        </div>
                        
                            
                            {toast}
                        
                    </div>
                </div>
            </div>

        </>
    )
}
